interface IVesselCabinCategories {
  inside: string;
  outside: string;
  balcony: string;
  suite: string;
}

export const VesselCabinCategories: IVesselCabinCategories = {
  inside: "inside",
  outside: "outside",
  balcony: "balcony",
  suite: "suite",
};
